/**
* this displays the fund members
*
* Created by Paul on 27/05/19
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import cx from 'classnames'
import { connect } from 'react-redux'
import moment from 'moment'
import { isEmpty } from '../../utility/utilities'

// action import
import { ActionCreator } from '../../actions/'

// Configurations
import constants from '../../constants'

// material-ui import
import { withStyles, makeStyles } from '@material-ui/styles'
import Typography from '@material-ui/core/Typography'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'

const styles = theme => ({
    gridroot: {
        flexGrow: 1,
    },
    card: {
        height: '100%',
    },
    title: {
        fontSize: 16,
    },
    pos: {
        marginBottom: 12,
    },
    card_body: {
        fontSize: 13,
    },
})

class FundMembers extends Component {

    getFullName(member) {
        let name = member.title.charAt(0).toUpperCase() + member.title.slice(1).toLowerCase() + ' ' + member.first_name

        if (!isEmpty(member.middle_name)) {
            name += ' ' + member.middle_name
        }

        return name + ' ' + member.last_name
    }

    renderMember (heading, data, fundType, index) {

        const { classes } = this.props

        return (
            <Grid item xs={12} md={6} key={ index }>
                <Card className={classes.card}>
                    <CardContent>
                        <Typography className={classes.title} variant="h5" component="h2">
                            { this.getFullName(data) }
                        </Typography>

                        <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                            { heading }{ index===0 && <span> - (Account Holder)</span>}
                        </Typography>
                        
                        <Grid container>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    Phone:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { data['phone'] }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    Email:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { data['email'] }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    Date of Birth:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { data['date_of_birth'] }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    TFN:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { data['tfn'] }
                                </Typography>
                            </Grid>
                        </Grid>

                        { fundType == 'CORPORATE' &&
                            <Grid container>
                                <Grid item xs={4}>
                                    <Typography className={classes.card_body}>
                                        Country of Birth:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography className={classes.card_body}>
                                        { data['country_of_birth'] }
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography className={classes.card_body}>
                                        Australian State of Birth:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography className={classes.card_body}>
                                        { data['state_of_birth'] }
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography className={classes.card_body}>
                                        Town/City of Birth:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography className={classes.card_body}>
                                        { data['city_of_birth'] }
                                    </Typography>
                                </Grid>
                            </Grid>
                        }

                        <Grid container>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    Residential Address:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { data['residential_address'] }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    Residential Unit#:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { data['residential_unit'] }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    Residential Suburb:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { data['residential_suburb'] }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    Residential State:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { data['residential_state'] }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    Residential Postcode:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { data['residential_postcode'] }
                                </Typography>
                            </Grid>
                        </Grid>

                        { index === 0 && data['use_residential_as_mailing'] === false &&
                            <Grid container>
                                <Grid item xs={4}>
                                    <Typography className={classes.card_body}>
                                        Postal Address:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography className={classes.card_body}>
                                        { data['postal_address'] }
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography className={classes.card_body}>
                                        Postal Unit #:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography className={classes.card_body}>
                                        { data['postal_unit'] }
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography className={classes.card_body}>
                                        Postal Suburb:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography className={classes.card_body}>
                                        { data['postal_suburb'] }
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography className={classes.card_body}>
                                        Postal State:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography className={classes.card_body}>
                                        { data['postal_state'] }
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography className={classes.card_body}>
                                        Postal Postcode:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography className={classes.card_body}>
                                        { data['postal_postcode'] }
                                    </Typography>
                                </Grid>
                            </Grid>
                        }

                    </CardContent>
                </Card>
            </Grid>
        )
    }

    render() {

        const { classes, isLoading, membersTrusteesInfoData, fundInfoData } = this.props
        
        return (
            <ExpansionPanelDetails>
                <div className={classes.gridroot}>
                    <Grid container spacing={3}>

                        { membersTrusteesInfoData.map(
                            (item,index)=>{ return this.renderMember(item['heading'],item['data'], fundInfoData['fund_type'], index) }
                        )}

                    </Grid>
                </div>
            </ExpansionPanelDetails>
        )
    }
}

// define the prop types
FundMembers.propTypes = {
    classes: PropTypes.object.isRequired,
    fundInfoData: PropTypes.object,
    membersTrusteesInfoData: PropTypes.array,
    isLoading: PropTypes.bool,
}

const mapStateToPros = (state) => {
    return {
        fundInfoData: state.fundState.fundInfoData,
        membersTrusteesInfoData: state.fundState.membersTrusteesInfoData,
        isLoading: state.fundState.isLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {

    }
}

export default connect(mapStateToPros,mapDispatchToProps)(withStyles(styles)(FundMembers))


// WEBPACK FOOTER //
// ./src/components/FundMembers/index.js